export const getInteractionKey = (orderNumber: string, contactId: number): string => {
  return `${orderNumber}-${contactId}`;
};
